import { graphql } from 'react-relay';

export const paymentCardsQuery = graphql`
  query paymentCardsQuery {
    paymentCards {
      result
      errors {
        code
        message
      }
      cards {
        id
        cardNo
        cardNm
        cardCd
        expireYear
        expireMonth
      }
    }
  }
`;
